module.exports = __webpack_public_path__ + "img/sex_etc_logo.12e3b7b9.jpg";